// Doğalgaz Mock Data
// Doğalgaz tesisatı, kombi ve proje takibi

export const dogalgazMalzemeler = [
    {
        id: 'dg-001',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-11',
        tedarikci: 'Gazkon',
        tedarikciFirmaId: 'f-060',
        kategori: 'boru',
        urunAdi: 'Çelik Boru DN20',
        aciklama: 'Galvanizli doğalgaz borusu',
        miktar: 300,
        birim: 'metre',
        birimFiyat: 85,
        toplamFiyat: 25500,
        durum: 'teslim',
        stokMiktar: 50,
        kullanilanMiktar: 250,
        uygulamaYeri: 'A Blok Kolon',
        insaatId: 'c-001',
        onay: 'onaylandi',
        not: 'Kolon tesisatı tamamlandı',
        createdAt: '2026-01-10T08:00:00Z',
        updatedAt: '2026-01-16T15:00:00Z',
    },
    {
        id: 'dg-002',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-11',
        tedarikci: 'Gazkon',
        tedarikciFirmaId: 'f-060',
        kategori: 'vana',
        urunAdi: 'Gaz Kesme Vanası 3/4"',
        aciklama: 'Daire giriş vanası',
        miktar: 40,
        birim: 'adet',
        birimFiyat: 250,
        toplamFiyat: 10000,
        durum: 'teslim',
        stokMiktar: 10,
        kullanilanMiktar: 30,
        uygulamaYeri: 'A Blok Daireler',
        insaatId: 'c-001',
        onay: 'onaylandi',
        not: 'Daire girişleri montajlandı',
        createdAt: '2026-01-10T08:00:00Z',
        updatedAt: '2026-01-17T14:00:00Z',
    },
    {
        id: 'dg-003',
        siparisTarihi: '2026-01-12',
        teslimTarihi: '2026-01-14',
        tedarikci: 'Bosch Termoteknoloji',
        tedarikciFirmaId: 'f-061',
        kategori: 'kombi',
        urunAdi: 'Bosch Condens 2500',
        aciklama: '24 kW Yoğuşmalı Kombi',
        miktar: 20,
        birim: 'adet',
        birimFiyat: 28000,
        toplamFiyat: 560000,
        durum: 'teslim',
        stokMiktar: 8,
        kullanilanMiktar: 12,
        uygulamaYeri: 'A Blok Daireler',
        insaatId: 'c-001',
        montajDurumu: 'devam',
        onay: 'bekliyor',
        not: 'Montaj devam ediyor',
        createdAt: '2026-01-12T10:00:00Z',
        updatedAt: '2026-01-17T16:00:00Z',
    },
    {
        id: 'dg-004',
        siparisTarihi: '2026-01-05',
        teslimTarihi: '2026-01-06',
        tedarikci: 'Bayraktar Sayaç',
        tedarikciFirmaId: 'f-062',
        kategori: 'sayac',
        urunAdi: 'Doğalgaz Sayacı G4',
        aciklama: 'Daire sayacı',
        miktar: 40,
        birim: 'adet',
        birimFiyat: 650,
        toplamFiyat: 26000,
        durum: 'teslim',
        stokMiktar: 5,
        kullanilanMiktar: 35,
        uygulamaYeri: 'A Blok Sayaç Odaları',
        insaatId: 'c-001',
        montajDurumu: 'tamamlandi',
        onay: 'onaylandi',
        not: 'Tüm sayaçlar montajlandı',
        createdAt: '2026-01-05T09:00:00Z',
        updatedAt: '2026-01-15T17:00:00Z',
    },
    {
        id: 'dg-005',
        siparisTarihi: '2026-01-15',
        teslimTarihi: null,
        tedarikci: 'Demirdöküm',
        tedarikciFirmaId: 'f-063',
        kategori: 'kombi',
        urunAdi: 'Demirdöküm Atromix',
        aciklama: '28 kW Yoğuşmalı Kombi',
        miktar: 20,
        birim: 'adet',
        birimFiyat: 32000,
        toplamFiyat: 640000,
        durum: 'bekliyor',
        stokMiktar: 0,
        kullanilanMiktar: 0,
        uygulamaYeri: 'A Blok Daireler',
        insaatId: 'c-001',
        montajDurumu: 'bekliyor',
        onay: 'bekliyor',
        not: 'Kalan daireler için sipariş',
        createdAt: '2026-01-15T11:00:00Z',
        updatedAt: '2026-01-15T11:00:00Z',
    },
];

// Doğalgaz kategorileri
export const dogalgazKategorileri = [
    { key: 'boru', label: 'Boru', icon: '🔧' },
    { key: 'vana', label: 'Vana', icon: '🔩' },
    { key: 'kombi', label: 'Kombi', icon: '🔥' },
    { key: 'sayac', label: 'Sayaç', icon: '📊' },
    { key: 'regulator', label: 'Regülatör', icon: '⚙️' },
];

// Onay durumları
export const onayDurumlari = [
    { key: 'bekliyor', label: 'Onay Bekliyor', color: 'warning' },
    { key: 'onaylandi', label: 'Onaylandı', color: 'success' },
    { key: 'reddedildi', label: 'Reddedildi', color: 'error' },
];

// İstatistikler
export const getDogalgazStats = (insaatId) => {
    const filtered = insaatId
        ? dogalgazMalzemeler.filter(s => s.insaatId === insaatId)
        : dogalgazMalzemeler;

    const toplamKalem = filtered.length;
    const teslimEdilen = filtered.filter(s => s.durum === 'teslim').length;
    const bekleyen = filtered.filter(s => s.durum === 'bekliyor').length;
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);
    const onaylanan = filtered.filter(s => s.onay === 'onaylandi').length;

    return {
        toplamKalem,
        teslimEdilen,
        bekleyen,
        toplamMaliyet,
        onaylanan,
        onayOrani: toplamKalem > 0 ? Math.round((onaylanan / toplamKalem) * 100) : 0,
    };
};

// Helper: insaata göre filtrele
export const getDogalgazByInsaat = (insaatId) => {
    if (!insaatId) return dogalgazMalzemeler;
    return dogalgazMalzemeler.filter(s => s.insaatId === insaatId);
};

// Helper: kategoriye göre filtrele
export const getDogalgazByKategori = (kategori, insaatId) => {
    let data = insaatId ? getDogalgazByInsaat(insaatId) : dogalgazMalzemeler;
    if (kategori) {
        data = data.filter(s => s.kategori === kategori);
    }
    return data;
};
